<template>
    <div>
        <div class="categorie" :class="{'active': curCategory == key, 'with-image-categorie': cat.groupImages && cat.groupImages.large }" v-for="(cat, key) in categories" :key="key" @click="setCurrentCat(key)">
            <img v-if="cat.groupImages && cat.groupImages.large" :src="getImagesURL(cat, 'groupImages', 'large')" >
            <span :class="{'with-image-span': cat.groupImages && cat.groupImages.large}" v-text="getProductLanguage(cat, 'groupName')"></span>
        </div>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import LocaleController from '../assets/controllers/LocaleController'

export default {
    name: 'SideBar',
    props: ['categories', 'curCategory'],
    data () {
        return {}
    },
    methods: {
        setCurrentCat: function (curKey) {
            this.$emit('changeCurCat', curKey)
            setTimeout(() => {
                document.getElementsByClassName('categorie active')[0].scrollIntoViewIfNeeded({ behavior: 'smooth' })
            }, 300)
        },
        getImage: function (cat) {
            try {
                return require(`../../static/icons/${cat.groupName.toLocaleLowerCase()}.svg`)
            } catch (error) {
                cat.image = false
                return null
            }
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");
    .categorie {
        position: relative;
        text-align: center;
        border-bottom: 1px solid @primary-dark;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: @categorie-font-color;
        height: 100%;
        max-height: 235px;
        background-color: @categorie-color;
        transition: all .2s linear;
        overflow-x: hidden;
        /* Garante posicionamento para WebView 83 */
        overflow: hidden;
        span {
            font-family: @default-font;
            font-size: 1.6rem;
            font-weight: 600;
            overflow: hidden;
            display: inline-block;
            background: var(--categorie-color);
            color: var(--categorie-font-color);
            padding: 10px 5px;
            opacity: .8;
            width: 100%;
            box-sizing: border-box;
            /* Fallback para WebView 83 e versões antigas */
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            /* Centralizado por padrão quando não há imagem */
            position: relative;
            text-align: center;
        }

        .with-image-span {
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }

        img {
            // max-width: 90%;
            // max-height: 171.4px;
            margin-bottom: 15px;
            height: auto;
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            height: 100%;
            object-fit: contain;
            // object-fit: cover;
            width: 100%;
        }
        &:active{
            background-color: @primary-light;
        }
        &.active{
            background-color: @primary-dark;
            color: @white;
            span {
                background-color: @primary-dark;
                color: @white;
            }
        }
    }

    .with-image-categorie {
        justify-content: end;
    }

    @media (max-width: 698px) { // Gertec SK210
        .categorie {
            max-height: 100px;
            span {
                font-size: 13px;
                padding: 5px 5px;
            }
        }
    }

    @media (min-width: 699px) and (max-width: 900px) {
        .categorie {
            height: 100%;
            max-height: 165px;
            span {
                font-size: 1rem;
            }
            .with-image-span {
                font-size: 1rem;
            }
        }
    }

    @media (min-width: 699px) and (max-width: 901px) { //@tablet
        .categorie {
            height: 100%;
            max-height: 145px;
            span {
                font-size: 1.2rem;
            }
        }
    }

    /* Correção específica para WebView 83 e versões antigas */
    @supports not (display: grid) {
        .categorie {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -moz-box-orient: vertical;
            -moz-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;

            .with-image-span {
                position: absolute !important;
                bottom: 0 !important;
                left: 0 !important;
                right: 0 !important;
                width: 100% !important;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue